import { ComplexTableCell, ComplexTableRow, ComplexTableRowRendererProps } from '@/components/ComplexTable';
import { Datetime, minMax } from '@/utils';

import ActionsDropdown from '@/components/ActionsDropdown';
import ActiveSwitch from '@/components/ActiveSwitch';
import { Button } from 'react-bootstrap';
import { CombineRuleIllegalCombineEnum } from '@/models/gen/graphql';
import { DATETIME_FE_FORMAT } from '@/constants';
import ImportContractProviderDropdown from '@/components/ImportContractProviderDropdown';
import NumberInput from '@/components/NumberInput';
import { ReactNode } from 'react';
import { useCombineDiscountDrawer } from '@/features/Settings/components/CombineDiscountDrawer';
import useConfirmation from '@/hooks/useConfirmation';

const CombineRulesTableRow = ({ index, item, data, getValue, onChange, onDelete }: ComplexTableRowRendererProps): ReactNode => {
  const { validity } = item;
  const contractId = getValue('contractId');
  const combineRuleId = getValue('id');
  const pickupWindow = getValue('pickupWindow');
  const turnaroundThreshold = getValue('turnaroundThreshold');
  const createdAt = getValue('createdAt');
  const createdBy = getValue('creator.fullName');
  const isAddition = !item?.data?.id;
  const providerDisplayName = getValue('provider.name');
  const illegalCombineSetting = getValue('illegalCombine');

  const setCombineDiscountDrawer = useCombineDiscountDrawer(({ setState }) => setState);

  const onEdit = (): void => {
    setCombineDiscountDrawer((current) => ({
      ...current,
      show: true,
      data: { combineRuleId: combineRuleId, airline: providerDisplayName },
    }));
  };

  const confirmDelete = useConfirmation({
    Body: { title: 'Delete Combine Rule?', message: 'Are you sure you want to delete this combine rule?' },
  });

  const handleDelete = async (): Promise<void> => {
    try {
      await confirmDelete();
      onDelete();
    } catch (err) {
      console.log('Delete Cancelled');
    }
  };

  return (
    <ComplexTableRow>
      <ComplexTableCell>
        {!isAddition && !!data?.contractId ? (
          providerDisplayName || '--'
        ) : (
          <ImportContractProviderDropdown
            name="contractId"
            value={contractId}
            onChange={onChange('contractId')}
            options={{ locale: { 'Select...': 'Airline' } }}
            isValid={validity?.contractId === true}
            isInvalid={validity?.contractId === false}
          />
        )}
      </ComplexTableCell>
      <ComplexTableCell>{createdBy || '--'}</ComplexTableCell>
      <ComplexTableCell>
        {createdAt ? new Datetime().setAsUTC(createdAt).toLocaleDatetime().format(DATETIME_FE_FORMAT) : '--'}
      </ComplexTableCell>
      <ComplexTableCell>
        <NumberInput
          name="pickupWindow"
          value={pickupWindow}
          onChange={(value: number): void => onChange('pickupWindow')(minMax(value, 0, 1440))}
          append={'mins'}
          placeholder="--"
          isDirty={!isAddition && pickupWindow !== data?.pickupWindow}
          isValid={isAddition && validity?.pickupWindow === true}
          isInvalid={validity?.pickupWindow === false}
        />
      </ComplexTableCell>
      <ComplexTableCell>
        {/* <NumberInput
          name="discount"
          value={discount}
          onChange={(value: number): void => onChange('discount')(minMax(value, 0, 100)?.toString?.())}
          append={'%'}
          placeholder="--"
          isDirty={!isAddition && discount !== (data?.discount ?? '')}
          isValid={isAddition && validity?.discount === true}
          isInvalid={validity?.discount === false}
        /> */}
        <Button className="w-50 center" variant="primary" disabled={!combineRuleId} onClick={onEdit}>
          VIEW DISCOUNT
        </Button>
      </ComplexTableCell>
      <ComplexTableCell>
        <NumberInput
          name="turnaroundThreshold"
          value={turnaroundThreshold}
          onChange={(value: number): void => onChange('turnaroundThreshold')(minMax(value, 0, 1440))}
          append={'mins'}
          placeholder="--"
          isDirty={!isAddition && turnaroundThreshold !== data?.turnaroundThreshold}
          isValid={isAddition && validity?.turnaroundThreshold === true}
          isInvalid={validity?.turnaroundThreshold === false}
        />
      </ComplexTableCell>
      <ComplexTableCell className="justify-content-center">
        <ActiveSwitch
          checked={illegalCombineSetting === CombineRuleIllegalCombineEnum.Warning}
          onChange={async (isChecked: boolean) =>
            onChange('illegalCombine')(isChecked ? CombineRuleIllegalCombineEnum.Warning : CombineRuleIllegalCombineEnum.Block)
          }
        />
      </ComplexTableCell>
      <ComplexTableCell className="text-center">
        <ActionsDropdown
          icon={<i className="fa fa-ellipsis-h fs-5" />}
          items={[{ key: index, label: 'DELETE', danger: true }]}
          className="ActionsCellDropdown text-center"
          onClick={handleDelete}
        />
      </ComplexTableCell>
    </ComplexTableRow>
  );
};

export default CombineRulesTableRow;
